// {
//   /**
//   * 指定したボタンにクリックイベントを設定する
//   * @param {string} buttonId ボタンのID
//   * @param {Function} callback 実行するコールバック関数
//   */
//   function setupUpsellButton(buttonId, callback) {
//     const button = document.getElementById(buttonId);
//     if (button) {
//       button.addEventListener('click', callback, false);
//     }
//   }

//   /**
//   * ボタンを無効化する
//   * @param {string} buttonId ボタンのID
//   */
//   function disableButton(buttonId) {
//     const button = document.getElementById(buttonId);
//     if (button) {
//       button.disabled = true;
//     }
//   }

//   /**
//   * 特定のデータ属性キーと一致する要素を検索する
//   * @param {string} dataKey 検索するデータ属性のキー
//   * @param {string} value 一致するべき値
//   * @returns {Element|null} 見つかった要素、または null
//   */
//   function findElementByDataKey(dataKey, value) {
//     const elements = document.querySelectorAll(`[${dataKey}]`);
//     for (const element of elements) {
//       if (element.getAttribute(dataKey) === value) {
//         return element;
//       }
//     }
//     return null;
//   }

//   /**
//   * URLから指定されたパラメータの値を取得する
//   * @param {string} paramName パラメータの名前
//   * @param {string} [url] URL (省略時は現在のURL)
//   * @returns {string|null} パラメータの値または null
//   */
//   function getUrlParameter(paramName, url = window.location.href) {
//     const escapedName = paramName.replace(/[[\]]/g, '\\$&');
//     const regex = new RegExp(`[?&]${escapedName}(=([^&#]*)|&|#|$)`);
//     const results = regex.exec(url);
//     if (!results) return null;
//     if (!results[2]) return '';
//     return decodeURIComponent(results[2].replace(/\+/g, ' '));
//   }

//   /**
//   * カート内の商品を置き換えるための共通関数
//   * @param {string} url リクエストURL
//   * @param {object} body リクエストボディ
//   * @returns {Promise} Fetch APIのレスポンスを返すPromise
//   */
//   function sendCartRequest(url, body) {
//     return fetch(url, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(body),
//     }).then(response => {
//       if (!response.ok) {
//         throw new Error(`リクエストに失敗しました: ${url}`);
//       }
//       return response.json();
//     });
//   }

//   /**
//   * カート内の商品を別の商品に置き換えます。
//   * @param {number} currentItemId - 削除する商品のID。
//   * @param {number} newItemId - 追加する商品のID。
//   * @param {number} quantity - 追加する商品の数量。
//   */
//   function replaceCartItem(currentItemId, newItemId, quantity) {
//     sendCartRequest('/cart/add.js', { items: [{ id: newItemId, quantity }] })
//       .then(() => sendCartRequest('/cart/change.js', { id: currentItemId.toString(), quantity: 0 }))
//       .then(() => location.reload())
//       .catch(error => {
//         console.error('カート内商品の置き換え中にエラーが発生しました:', error);
//       });
//   }

//   /**
//   * 商品をカートから削除する関数
//   * @param {string} productKey 商品のキー
//   * @returns {Promise} Fetch APIのレスポンスを返すPromise
//   */
//   function removeProductFromCart(productKey) {
//     console.log('商品をカートから削除中:', productKey);
//     return sendCartRequest('/cart/change.js', { id: productKey, quantity: 0 });
//   }

//   /**
//   * 商品をカートに追加する関数
//   * @param {number} productId 商品ID
//   * @param {string} sellingPlanId サブスクリプションプランID
//   * @returns {Promise} Fetch APIのレスポンスを返すPromise
//   */
//   function addProductToCart(productId, sellingPlanId) {
//     console.log('商品をカートに追加中:', productId);
//     return sendCartRequest('/cart/add.js', { id: productId, quantity: 1, selling_plan: sellingPlanId });
//   }
// }

// {
//   // DOM Elements
//   const checkoutButtonJQuery = $('#btn__checkout');
//   const cartNote = document.getElementById('CartSpecialInstructions');
//   const cartNotePlaceholder = document.getElementById('CartSpecialInstructionsFake');
//   const cartRows = document.getElementsByClassName('js-cartRow');

//   /**
//    * カートノートを更新し、必要に応じてチェックアウト処理をトリガーします。
//     * @param {string} newNote - カートに追加する新しいノート内容。
//     * @param {boolean} submit - カートノート更新後にチェックアウトをトリガーするかどうか。
//     */
//   function updateCartNote(newNote, submit) {
//     fetch('/cart/update.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify({ note: newNote })
//     })
//       .then(res => res.json())
//       .then(() => {
//         return fetch('/cart.js');
//       })
//       .then(res => res.json())
//       .then(data => {
//         cartNote.value = data.note;
//         if (submit) {
//           checkoutButtonJQuery.trigger('click');
//         }
//       })
//       .catch(error => console.error('カートノートの更新中にエラーが発生しました:', error));
//   }

//   /**
//    * サブスクリプションおよび商品タイプの条件に基づいてカートノートを制御します。
//     * 定期購入&Lypo-C商品新規購入者 -> 【新規定期】【新規購入】追加
//     * 定期購入 -> 【新規定期】追加
//     * Lypo-C商品新規購入者 -> 【新規購入】追加
//     * @param {boolean} [submit=false] - カートノート更新後にチェックアウトをトリガーするかどうか。
//     * @param {boolean} [isNewCustomer=false] - 新規顧客かどうか。
//     */
//   function handleCartNoteUpdate(submit = false, isNewCustomer = false) {
//     const noteValue = cartNotePlaceholder.value;
//     let hasSubscription = false;
//     let hasLypoProduct = false;

//     Array.from(cartRows).forEach(row => {
//       if (row.dataset.subscription === 'true') {
//         hasSubscription = true;
//       }
//       if (row.dataset.lypo === 'true') {
//         hasLypoProduct = true;
//       }
//     });

//     let deliveryOption = '';
//     const deliveryOptionElement = document.getElementById('js-deliveryOption');
//     if (deliveryOptionElement) {
//       const selectedOption = document.querySelector('input[name="delivery_option"]:checked');
//       if (selectedOption && selectedOption.value === '常温配送') {
//         deliveryOption = '【常温配送】';
//       }
//     }

//     const isEligibleForNewCustomer = hasLypoProduct && isNewCustomer;

//     if (hasSubscription && isEligibleForNewCustomer) {
//       updateCartNote(`${noteValue}${deliveryOption}【新規定期】【新規購入】`, submit);
//     } else if (hasSubscription) {
//       updateCartNote(`${noteValue}${deliveryOption}【新規定期】`, submit);
//     } else if (isEligibleForNewCustomer) {
//       updateCartNote(`${noteValue}${deliveryOption}【新規購入】`, submit);
//     } else {
//       updateCartNote(`${noteValue}${deliveryOption}`, submit);
//     }
//   }

//   /**
//    * カートノートのプレースホルダーから特定のタグを削除します。
//     */
//   function cleanCartNotePlaceholder() {
//     let noteValue = cartNotePlaceholder.value;
//     noteValue = noteValue.replace(/【新規定期】|【新規購入】|【常温配送】/g, '');
//     cartNotePlaceholder.value = noteValue;
//   }
// }

// /**
//  * カートから削除ボタンが押されたときの処理
//  * カートからアイテムを削除し、ページをリロード
//  * htmlを最新のカート内容に更新する
//  */
// {
//   // DOM Elements
//   const checkoutButtonNative = document.getElementById('btn__checkout2');
//   const deleteButtons = document.getElementsByClassName('js-deleteBtn');

//   // カートから削除のボタンにイベントを登録
//   Array.from(deleteButtons).forEach(button => {
//     button.addEventListener('click', () => {
//       checkoutButtonNative.classList.add('disabled');

//       // 削除ボタンに対応するアイテムのlineでjsonデータを作成する
//       const line = button.dataset.line;
//       const data = {
//         line,
//         quantity: 0
//       };

//       // 削除ボタンに対応するアイテムをカートから削除する
//       fetch('/cart/change.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(data)
//       })
//         .then(res => res.json())
//         .then(() => {
//           // カートからの削除が成功したらページをリロードしてhtmlを最新に更新する
//           location.reload();
//         })
//         .catch(error => console.error('削除処理中にエラーが発生しました:', error));
//     });
//   });
// }


function setupUpsellButton(e,t){e=document.getElementById(e);e&&e.addEventListener("click",t,!1)}
function disableButton(e){e=document.getElementById(e);e&&(e.disabled=!0)}function findElementByDataKey(e,t){for(const n of document.querySelectorAll(`[${e}]`))if(n.getAttribute(e)===t)return n;return null}
function getUrlParameter(e,t=window.location.href){e=e.replace(/[[\]]/g,"\\$&"),e=new RegExp(`[?&]${e}(=([^&#]*)|&|#|$)`).exec(t);return e?e[2]?decodeURIComponent(e[2].replace(/\+/g," ")):"":null}
function sendCartRequest(t,e){return fetch(t,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(e)}).then(e=>{if(e.ok)return e.json();throw new Error("リクエストに失敗しました: "+t)})}
function replaceCartItem(e,t,n){sendCartRequest("/cart/add.js",{items:[{id:t,quantity:n}]}).then(()=>sendCartRequest("/cart/change.js",{id:e.toString(),quantity:0})).then(()=>location.reload()).catch(e=>{console.error("カート内商品の置き換え中にエラーが発生しました:",e)})}
function removeProductFromCart(e){return console.log("商品をカートから削除中:",e),sendCartRequest("/cart/change.js",{id:e,quantity:0})}
function addProductToCart(e,t){return console.log("商品をカートに追加中:",e),sendCartRequest("/cart/add.js",{id:e,quantity:1,selling_plan:t})}

// アップセルのボタンでカート更新が成功したあと、GTM（dataLayer）へ upsell_click を送ってから再読み込みする（REQUEST_SYSTEM-729）
//   params: { brand: 'vc', type: 'sub'|'single'|'quantity', boxes: 変更後の箱数 }
//   upsell_name は「ブランド_種類_N箱」（例: vc_sub_1box）
//   GTM の処理が終わる（eventCallback）か、最長1秒で再読み込みする。GTM が無いときはすぐ再読み込みする
function trackUpsellAndReload(params) {
  var finished = false;
  function finish() {
    if (finished) return;
    finished = true;
    location.reload();
  }
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'upsell_click',
      upsell_brand: params.brand,
      upsell_type: params.type,
      upsell_boxes: params.boxes,
      upsell_name: [params.brand, params.type, params.boxes + 'box'].join('_'),
      eventCallback: finish,
      eventTimeout: 1000
    });
  } catch (e) {
    console.error(e);
  }
  if (window.google_tag_manager) {
    setTimeout(finish, 1000);
  } else {
    finish();
  }
}


function updateCartNote(e, t) {
  const y = document.getElementById("btn__checkout"),
    z = document.getElementById("CartSpecialInstructions");
  fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ note: e }),
  })
    .then((e) => e.json())
    .then(() => fetch("/cart.js"))
    .then((e) => e.json())
    .then((e) => {
      z.value = e.note;
    })
    .catch((e) => {
      console.error("カートノートの更新中にエラーが発生しました:", e);
    })
    .finally(() => {
      y.click();
    });
}
function handleCartNoteUpdate(e = !1, t = !1) {
  const A = document.getElementById("CartSpecialInstructionsFake"),
    B = document.getElementsByClassName("js-cartRow");
  var n = A.value;
  let o = !1,
    a = !1,
    r =
      (Array.from(B).forEach((e) => {
        "true" === e.dataset.subscription && (o = !0),
          "true" === e.dataset.lypo && (a = !0);
      }),
      "");
  document.getElementById("js-deliveryOption") &&
    (c = document.querySelector('input[name="delivery_option"]:checked')) &&
    "常温配送" === c.value &&
    (r = "【常温配送】");
  var c = a && t;
  o && c
    ? updateCartNote("" + n + r + "【新規定期】【新規購入】", e)
    : o
    ? updateCartNote("" + n + r + "【新規定期】", e)
    : updateCartNote(c ? "" + n + r + "【新規購入】" : "" + n + r, e);
}
function cleanCartNotePlaceholder() {
  const A = document.getElementById("CartSpecialInstructionsFake")
  let e = A.value;
  (e = e.replace(/【新規定期】|【新規購入】|【常温配送】/g, "")),
    (A.value = e);
}


document.addEventListener('DOMContentLoaded', () => {
  const T = document.getElementById("btn__checkout2"),
    U = document.getElementsByClassName("js-deleteBtn");
  Array.from(U).forEach((t) => {
    t.addEventListener("click", () => {
      T.classList.add("disabled");
      var e = t.dataset.line;
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: e, quantity: 0 }),
      })
        .then((e) => e.json())
        .then(() => {
          location.reload();
        })
        .catch((e) => console.error("削除処理中にエラーが発生しました:", e));
    });
  });
})
